import React, { useState, useEffect } from 'react';

import { getRecordIDFromUID } from './Common';

import { client, timer } from '../utils/apiClient';
import { Button, ButtonToolbar, FlexboxGrid, List, Stack } from 'rsuite';

import {
  MdOutlineAddCircle as IconMore,
  MdOutlineRemoveCircle as IconLess,
  MdOutlineSync as IconRefresh,
} from 'react-icons/md';

import { apiLimit, RECORD_TYPES } from '../constants';

import { COLOURS } from '../styles';
import { defaultCardStyle, headerCardStyle, progressCardStyle } from '../styles';
import ResizeObserver from 'resize-observer-polyfill';
import { LoadingView } from './DisplayItems';
import { devLog } from '../utils/devLog';

import { getDevice, listDevices } from '../graphql/queries';
export const UserView = (props) => {
  if (!window.ResizeObserver) {
    window.ResizeObserver = ResizeObserver;
  }

  return (
    <Stack alignItems="stretch" justifyContent="flex-start" direction="column" style={{ marginTop: 8 }}>
      <Stack alignItems="center" justifyContent="space-between" spacing={8} style={headerCardStyle}>
        <Stack.Item>Users</Stack.Item>
        <Stack.Item alignSelf="flex-end">
          {/* <ButtonToolbar>
            {(props.loading === false) &&
            <Button
              appearance="primary"
              color="blue"
              size="sm"
              endIcon={props.showList ? <IconLess /> : <IconMore />}
              onClick={props.onShowListChanged}
            >
              {props.showList ? "Less" : "More"}
            </Button>}
            <Button
              appearance="primary"
              color="blue"
              size="sm"
              endIcon={<IconRefresh />}
              loading={props.loading}
              onClick={props.onRefresh}
            >
              Refresh
            </Button>
          </ButtonToolbar> */}
        </Stack.Item>
      </Stack>
      {props.loading === true ? <LoadingView progress={props.progress} /> : <Stack.Item>Users</Stack.Item>}
    </Stack>
  );
};

async function fetchUsers(loginId) {
  let nextToken = null;
  let UserItems = [];
  do {
    try {
      const eventFromAPI = await client.graphql({
        query: listDevices,
        variables: {
          recordType: RECORD_TYPES.ACCESS + loginId,
          nextToken,
        },
      });
      UserItems = UserItems.concat(eventFromAPI.data.listDevices.items);
      nextToken = eventFromAPI.data.listDevices.nextToken;
    } catch (error) {
      devLog('fetch Users', error);
      await timer(1000);
    }
  } while (nextToken != null);
  // UserItems' own recordType field embeds this loginId (an email, in a
  // Cognito email-based pool) — log a count, not the records themselves.
  devLog('FetchingUsers, count:', UserItems.length);
}

export async function fetchUserRecord(loginId) {
  let UserItems = null;
  let record_ID = 'UID_0000000000000000_DT_XXXX';
  try {
    const URFromAPI = await client.graphql({
      query: getDevice,
      variables: {
        recordType: RECORD_TYPES.USER + loginId,
        recordID: record_ID,
        limit: apiLimit,
      },
    });
    UserItems = URFromAPI.data.getDevice;
  } catch (error) {
    devLog('Error: fetch User Record:', error);
    await timer(250);
  }
  // UserItems' own recordType field embeds this loginId (an email, in a
  // Cognito email-based pool) — log whether one was found, not the record.
  devLog('Fetched User Record:', UserItems ? 'found' : 'not found');
  return UserItems;
}

export async function fetchUserAccessRecord(loginId, deviceUID) {
  let UserItems = null;
  let record_ID = getRecordIDFromUID(deviceUID);
  try {
    const UARFromAPI = await client.graphql({
      query: getDevice,
      variables: {
        recordType: RECORD_TYPES.ACCESS + loginId,
        recordID: record_ID,
        limit: apiLimit,
      },
    });
    UserItems = UARFromAPI.data.getDevice;
  } catch (error) {
    devLog('Error: fetch User Access Record for ID', deviceUID, record_ID, error);
    await timer(250);
  }
  // UserItems' own recordType field embeds this loginId (an email, in a
  // Cognito email-based pool) — log whether one was found, not the record.
  devLog('Fetching User Access for', record_ID, UserItems ? 'found' : 'not found');
  return UserItems;
}

export function listUsers() {
  const cognitoidentityserviceprovider = new AWS.CognitoIdentityServiceProvider({
    apiVersion: '2016-04-18',
    region: 'eu-central-1',
    credentials: Auth.essentialCredentials(credentials),
  });
  var params = {
    UserPoolId: environment.amplify.Auth.userPoolId /* required */,
    AttributesToGet: ['email'],
    Limit: 0,
  };
  cognitoidentityserviceprovider.listUsers(params, function (err, data) {
    if (err)
      console.error(err, err.stack); // an error occurred
    // Each user's own Attributes (AttributesToGet: ["email"]) embeds
    // every pool member's email — log a count, not the payload.
    else devLog('listUsers, count:', data.Users?.length ?? 0);
  });
}
